import "core-js/stable";
import "regenerator-runtime/runtime";
window.Highcharts = require('highcharts');
window.numbro = require('numbro');
import "../src/filer/filer2.js";
import "../src/filer/csv_export_form.js";
import "../src/stock/report_error.js";
import "../src/stock/email_registration.js";
import "../src/filer/email_alert_dialog.js";
import "../src/filer/filer_subsidiary.js";


//import * as peer from './filer/filer_peer_groups.js';


//import "@babel/polyfill";
//import "iterators-polyfill";
//import "core-js/fn/symbol/iterator.js";
//import "core-js/es6/symbol.js";
import Vue from 'vue'
import peerstore from '../src/filer/peer_store/';
//import filerstore from './whalewisdom/store/';
global.peerstore = peerstore;


import App from '../src/filer/filer_backtest_app.vue'
import PeerApp from '../src/filer/peer_groups.vue'

import '../src/common/styles/dashboard.scss'

Vue.config.productionTip = false
// Apply packages

const opts={
    icons: {
        iconfont: 'md' // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4'
    },
    theme: {
        themes: {
            light: {
                'primary': '#66C6BA',
                'primary-light': '#99F9EC',
                'primary-dark': '#30958A',
                'accent': '#FFB783',
                'accent-light': '#FFE9B3',
                'accent-dark': '#C98755',
                'base-bg': '#FAFAFA',
                'blue': '#7293CB',
                'navy-blue': '#196B8F',
                'dark-blue': '#303F48'
            }
        }
    }

}
import Vuetify from 'vuetify'
Vue.use(Vuetify)
import 'vuetify/dist/vuetify.min.css'

// App
import '@/components'
import store from '@/store'

Vue.config.productionTip = process.env.NODE_ENV === 'production'

new Vue({
    vuetify: new Vuetify(opts),
    store,
    render: h => h(App),
    created: () => store.dispatch('initFilerStore')
}).$mount('#filerdashboard')
document.addEventListener('DOMContentLoaded', () => {
    console.log("dom loaded");


    jQuery(document).on( 'shown.bs.tab', 'a[data-toggle="tab"]', function (e) { // on tab selection event
        if ($('#peer-group-container').is(':visible') && !whalewisdom.Filer.peer_groups_init){
            new Vue({
                vuetify: new Vuetify(opts),
                el: "#peer-group-container",
                //   router,
                store: peerstore,
                render: h => h(PeerApp),
                created: () => peerstore.dispatch('initPeerGroupStore')
            })
            whalewisdom.Filer.peer_groups_init=true;
        }
    })

  /*  new Vue({
        el: "#peer-group-container",
        //   router,
        store: peerstore,
        render: h => h(PeerApp),
        created: () => peerstore.dispatch('initPeerGroupStore')
    })*/
/*
    new Vue({
        el: "#filerdashboard",
        //   router,
        store: filerstore,
        render: h => h(App),
        created: () => filerstore.dispatch('initFilerStore')
    })
*/
/*

*/

    // console.log(app)
})

/*

if (typeof angular != 'undefined') {
        angular.bootstrap(document.getElementById("filerdashboard"), ['filerdashboard']);
}*/

